/**
 * Centralized Timer Manager
 * Tracks all setTimeout and setInterval to prevent memory leaks
 */

class TimerManager {
  constructor() {
    this.timers = new Map();
    this.intervals = new Map();
  }

  setTimeout(callback, delay, key) {
    // Clear existing timer with same key
    this.clearTimeout(key);
    
    const id = setTimeout(() => {
      callback();
      this.timers.delete(key);
    }, delay);
    
    this.timers.set(key, id);
    return id;
  }

  setInterval(callback, delay, key) {
    // Clear existing interval with same key
    this.clearInterval(key);
    
    const id = setInterval(callback, delay);
    this.intervals.set(key, id);
    return id;
  }

  clearTimeout(key) {
    const id = this.timers.get(key);
    if (id !== undefined) {
      clearTimeout(id);
      this.timers.delete(key);
    }
  }

  clearInterval(key) {
    const id = this.intervals.get(key);
    if (id !== undefined) {
      clearInterval(id);
      this.intervals.delete(key);
    }
  }

  clearAll() {
    // Clear all timers
    this.timers.forEach(id => clearTimeout(id));
    this.timers.clear();
    
    // Clear all intervals
    this.intervals.forEach(id => clearInterval(id));
    this.intervals.clear();
    
    console.log('✅ All timers cleared');
  }

  getStats() {
    return {
      activeTimers: this.timers.size,
      activeIntervals: this.intervals.size,
      total: this.timers.size + this.intervals.size,
    };
  }
}

// Create singleton instance
const timerManager = new TimerManager();

// Make it available globally for debugging
if (typeof window !== 'undefined') {
  window.timerManager = timerManager;
}

export default timerManager;

// Usage:
// import timerManager from './timerManager';
// 
// timerManager.setTimeout(() => console.log('Hello'), 1000, 'my-timer');
// timerManager.setInterval(() => console.log('Tick'), 1000, 'my-interval');
// timerManager.clearTimeout('my-timer');
// timerManager.clearInterval('my-interval');
// timerManager.clearAll(); // Clear everything on unmount
